import BubbleImages		from './bubble-images'
import Image 			from './image'
import Quote 			from './quote'
import Text 			from './text'
import Video 			from './video'

export default {
	BubbleImages,
	Image,
	Quote,
	Text,
	Video
}